import { sharePointAccess as sharePointServerSideAccess } from '@qdabra/forms-shared/sharePoint';
import { pick } from 'ramda';
import sharePointClientSideAccess from './sharePointClientSideAccess';
import { shouldUseClient } from './sharePointHelper';

const { sharePointSettings } = window.qd.formsViewer.preloadData;

// list of methods that are only implemented on server-side
const serverOnlyMethods = ['getTaxonomyFieldsSchemaAsync'];

const makeClientSideAccess = (serverSide, showWait) => ({
    ...sharePointClientSideAccess({ showWait }),
    ...pick(serverOnlyMethods, serverSide),
});

const getShPAccess = (apiBase, { showWait } = {}) => {
    const serverSide = sharePointServerSideAccess(apiBase);

    return shouldUseClient(sharePointSettings)
        ? makeClientSideAccess(serverSide, showWait)
        : serverSide;
};

export default getShPAccess;
